import { Button, Divider, Link, Stack, Typography } from "@mui/material";
import { PDFDocIcon } from "../../../../../@lib/icons";
import { CoverImage } from "../../../../../components";
import imagePlaceholder from "../../../../../@lib/images/image-placeholder.svg";
import { baseURL } from "../../../../../utils/constants";
import {
  ConditionalRenderer,
  useLanguageTranslator,
  StatusTag,
} from "../../../../../components";

function LeftSide({ data }: any) {
  const { translator } = useLanguageTranslator();
  return (
    <>
      <CoverImage
        image={
          data?.picture?.source
            ? `${baseURL}${data?.picture?.source}`
            : imagePlaceholder
        }
        height={400}
        mb={2}
      />
      <StatusTag label={data?.statusLabel} status={data?.status} />
      <Typography variant="h5" fontWeight={300} mt={1}>
        {translator(`Rejection Reason`)}: {data?.rejectionReason}
      </Typography>
      <Typography variant="h5" mt={1}>
        {data?.title}
      </Typography>
      <Typography component="p" variant="caption">
        {data?.description}
      </Typography>
      <ConditionalRenderer condition={!data?.document?.source}>
        <Typography variant="h3" textAlign={"center"} mt={2}>
          {translator("No Document")}
        </Typography>
      </ConditionalRenderer>
      <ConditionalRenderer condition={data?.document?.source}>
        <Stack
          sx={{
            my: 2,
            p: 1,
            border: "1px solid #F1F1F1",
            borderRadius: "10px",
          }}
          direction={{ lg: "row" }}
          alignItems={{ lg: "center" }}
          justifyContent={{ lg: "space-between" }}
        >
          <div style={{ display: "flex" }}>
            <Stack
              sx={{
                backgroundColor: "#fff2f2",
                width: "90px",
                height: "82px",
                position: "relative",
                zIndex: "0",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ position: "absolute", zIndex: "1000" }}>
                <PDFDocIcon />
              </div>
            </Stack>
            <Stack direction={{ lg: "column" }} sx={{ mx: 1 }}>
              <Typography
                variant="h4"
                fontWeight={600}
                color={"#494E54"}
                fontSize={"15px"}
                mt={2}
                gutterBottom
                title={data?.document?.originalFilename}
              >
                {data?.document?.originalFilename?.length > 40
                  ? `${data?.document?.originalFilename?.slice(0, 40)}...`
                  : data?.document?.originalFilename}
              </Typography>
              <Typography
                variant="h4"
                fontWeight={600}
                color={"#494E54"}
                fontSize={"15px"}
                gutterBottom
                title={data?.documentTitle}
              >
                {data?.documentTitle?.length > 40
                  ? `${data?.documentTitle?.slice(0, 40)}...`
                  : data?.documentTitle}
              </Typography>
            </Stack>
          </div>
          <Stack
            direction={{ lg: "column" }}
            justifyContent={{ lg: "space-between" }}
          >
            <Link href={`${baseURL}${data?.document?.source}`} target="_blank">
              <Button
                sx={{
                  px: 5,
                  backgroundColor: "#F6A000",
                  color: "#ffffff",
                  "&:hover": {
                    backgroundColor: "#D48B00",
                  },
                  width: "100%",
                }}
              >
                {translator("dashboardTableHead.View")}
              </Button>
            </Link>
            <Button
              sx={{
                px: 6,
                mt: 1,
                backgroundColor: "#00AAB0",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#00838A",
                },
              }}
              onClick={() => {
                const fileUrl = `${baseURL}${data?.document?.source}`;
                fetch(fileUrl)
                  .then((response) => response.blob())
                  .then((blob) => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.download =
                      data?.document?.originalFilename || "Document.pdf";
                    link.click();
                    window.URL.revokeObjectURL(url);
                  })
                  .catch((err) =>
                    console.error("Error downloading the file", err)
                  );
              }}
            >
              {translator("Download")}
            </Button>
          </Stack>
        </Stack>
      </ConditionalRenderer>
      <Divider
        component="div"
        role="presentation"
        sx={{
          border: "1px solid #F1F1F1",
        }}
      />
    </>
  );
}

export { LeftSide };
